<!-- eslint-disable vue/no-unused-vars -->
<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <div class="container-fluid">
      <!-- <Breadcrumbs main="Monitoring Periods" :path="breadcrumbPath" /> -->

      <el-row class="m-0 width-100-p mt-3">

        <!-- section for create verramp -->
        <el-col v-if="createOpen" class="d-flex align-item-center mb-20" :span="$vuetify.display.width < 1500 ? 24 : 24">
          
          <div class="row m-0 width-100-p">
            <div
              class="row m-0 py-3 width-100-p bg-me-primary border-color-light rounded-4"
            >
            <el-row :span="24">
              <el-col :span="23">
                <h5 class="text-white mt-3 ml-1">Create monitoring report</h5>
              </el-col>
              <el-col :span="1" style="text-align: end;">
                  <el-image
                    class="arrow-btn"
                    style="width: 14px; height: 14px;"
                    :src="
                        require('@/assets/arrow-right.png')
                      "
                    fit="cover"
                    @click="createOpen = !createOpen"
                  />
              </el-col>
            </el-row>
              
            <el-col class="mb-2" :span="24">
                <div class="row m-0">
                  <el-col
                    span="24"
                    class="d-flex align-item-center"
                    :class="
                      $vuetify.display.width < 500
                        ? 'x-center mt-2'
                        : 'justify-start'
                    "
                    style="padding-left: 0px;"
                  >
                    <!-- search_by dropdown -->
                    <el-dropdown
                      trigger="click"
                      class="filter-drop"
                      @command="handleSelectSearchBy"
                    >
                      <el-button
                        color="#0D3937"
                        class="height-40 border-color-light rounded-3"
                        :style="$vuetify.display.width >= 500 ? 'max-width: 243px;' : ''"
                      >
                        <svg class="stroke-icon width-20 height-20">
                          <use
                            href="@/assets/svg/icon-sprite.svg#stroke-date"
                          ></use>
                        </svg>
                        <span
                          class="text-white pl-3"
                          v-if="
                            $vuetify.display.width >= 1007 && $vuetify.display.width <= 1012
                          "
                        >
                        {{ 
                           "Filter by monitoring period"
                          }}
                        </span>
                        <span class="text-white pl-3" v-else>
                            {{ 
                           "Filter by monitoring period"
                          }}
                        </span>
                      </el-button>
                      <template #dropdown>
                        <el-dropdown-menu>
                          <el-dropdown-item
                            v-for="(item, index) in monitoringDataList"
                            :key="index"
                            :command="item.name"
                            @click="handleSelectMP(item.id, item.name)"
                          >
                            {{ convertLabel(item.name) }}
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </template>
                    </el-dropdown>
             
                    <div
                      v-if="displayMPList_show && $vuetify.display.width >= 500"
                      class="selected-mp-wrapper"
                    >
                      <span class="selected-mp-text">{{ selectedMPName }}</span>
                      <el-button @click="clearSelectedMP" class="clear-btn" type="text">
                        <svg class="svg-small">
                          <use href="@/assets/svg/icon-sprite.svg#x-mark" />
                        </svg>
                      </el-button>
                    </div>

                  </el-col>
                
                </div>
            </el-col>

            <el-col v-if="$vuetify.display.width < 500" span="24">
               <div
                      v-if="displayMPList_show"
                      class="selected-mp-wrapper"
                    >
                      <span class="selected-mp-text">{{ selectedMPName }}</span>
                      <el-button @click="clearSelectedMP" class="clear-btn" type="text">
                        <svg class="svg-small">
                          <use href="@/assets/svg/icon-sprite.svg#x-mark" />
                        </svg>
                      </el-button>
                    </div>
            </el-col>
  
            <DataTable
                v-if="displayMPList_show"
                :loadingProp="loading"
                :usersDataProp="filter_monitoring"
                :totalRowProp="total_items"
                @tableAction="handleTableAction"
              />
          
            <el-col
                  v-if="displayMPList_show"
                    :span="4"
                    class="d-flex align-item-center"
                  >
                    <el-button
                      color="#ddf0ac"
                      @click.stop="handleReload"
                      size="small"
                      class="height-40 rounded-2 m-0 ml-2"
                    >
                      <i class="fa fa-plus pr-2"></i>
                      <span class="moderat-btn-apply"> Create </span>
                    </el-button>
            </el-col>

            </div>
          </div>
        </el-col>

         <!-- section for send verramp -->
        <el-col v-if="sendOpen" class="d-flex align-item-center" :style="$vuetify.display.width < 1500 ? 'margin-top: 20px' : ''" :span="$vuetify.display.width < 1500 ? 24 : 24">
          
          <div class="row m-0 width-100-p">
            <div
              class="row m-0 py-3 width-100-p bg-me-primary border-color-light rounded-4"
            >
             
            <el-row :span="24">
              <el-col :span="23">
                <h5 class="text-white mt-3 ml-1">Send monitoring report</h5>
              </el-col>
              <el-col :span="1" style="text-align: end;">
                  <el-image
                    class="arrow-btn"
                    style="width: 14px; height: 14px;"
                    :src="
                        require('@/assets/arrow-right.png')
                      "
                    fit="cover"
                    @click="sendOpen = !sendOpen"
                  />
              </el-col>
            </el-row>

              <el-col class="mb-2" :span="24">
                <div class="row m-0">
                  
                  <el-col
                    span="24"
                    class="d-flex align-item-center"
                    :class="
                      $vuetify.display.width < 500
                        ? 'x-center mt-2'
                        : 'justify-start'
                    "
                    style="padding-left: 0px;"
                  >
                    <!-- search_by dropdown -->

                    <el-dropdown
                      trigger="click"
                      class="filter-drop"
                      @command="handleSelectSearchBy"
                    >
                      <el-button
                        color="#0D3937"
                        class="height-40 border-color-light rounded-3"
                        :style="$vuetify.display.width >= 500 ? 'max-width: 243px;' : ''"
                      >
                        <svg class="stroke-icon width-20 height-20">
                          <use
                            href="@/assets/svg/icon-sprite.svg#stroke-date"
                          ></use>
                        </svg>
                        <span
                          class="text-white pl-3"
                          v-if="
                            $vuetify.display.width >= 1007 && $vuetify.display.width <= 1012
                          "
                        >
                        {{ 
                           "Filter by monitoring period"
                          }}
                        </span>
                        <span class="text-white pl-3" v-else>
                            {{ 
                           "Filter by monitoring period"
                          }}
                        </span>
                      </el-button>
                      <template #dropdown>
                        <el-dropdown-menu>
                          <el-dropdown-item
                            v-for="(item, index) in monitoringDataList"
                            :key="index"
                            :command="item.name"
                            @click="handleSelectSendMP(item.id, item.name)"
                          >
                            {{ convertLabel(item.name) }}
                          </el-dropdown-item>
                        </el-dropdown-menu>
                      </template>
                    </el-dropdown>
 
                    <div
                      v-if="displaySendMPList_show && $vuetify.display.width >= 500"
                      class="selected-mp-wrapper"
                    >
                      <span class="selected-mp-text">{{ selectedSendMPName }}</span>
                      <el-button @click="clearSelectedSendMP" class="clear-btn" type="text">
                        <svg class="svg-small">
                          <use href="@/assets/svg/icon-sprite.svg#x-mark" />
                        </svg>
                      </el-button>
                    </div>

                  </el-col>
                
                </div>
              </el-col>

              <el-col v-if="$vuetify.display.width < 500" span="24">
               <div
                      v-if="displaySendMPList_show"
                      class="selected-mp-wrapper"
                    >
                      <span class="selected-mp-text">{{ selectedSendMPName }}</span>
                      <el-button @click="clearSelectedSendMP" class="clear-btn" type="text">
                        <svg class="svg-small">
                          <use href="@/assets/svg/icon-sprite.svg#x-mark" />
                        </svg>
                      </el-button>
                    </div>
              </el-col>
  
              <DataTable
                v-if="displaySendMPList_show"
                :loadingProp="loading"
                :usersDataProp="filter_Send_monitoring"
                :totalRowProp="total_items"
                @tableAction="handleTableAction"
              />
              <el-col
                    v-if="displaySendMPList_show"
                    :span="4"
                    class="d-flex align-item-center"
                  >
                    <el-button
                      color="#ddf0ac"
                      @click.stop="handleSend"
                      size="small"
                      class="height-40 rounded-2 m-0 ml-2"
                      :class="
                        $store.state.auth.user != null &&
                        !$store.state.auth.user.is_auditor
                          ? 'width-70-p'
                          : 'width-40-p'
                      "
                    >
                      <i class="fa fa-paper-plane pr-2"></i>
                      <span class="moderat-btn-apply"> Send </span>
                    </el-button>

              </el-col>
            </div>
          </div>
        </el-col>

      </el-row>
    </div>
  </template>
  
  <script>

  import XLSX from "xlsx";
  import UserService from "../../../services/user.service";
  import DataTable from "./mpTable.vue";
  import { createLoadingInstance } from "../common/common-tools";
  import { ElMessageBox } from "element-plus";

//   import { convertToTitleCase } from "../../dashboard/common/common-tools";
  export default {
    // eslint-disable-next-line vue/multi-word-component-names
    name: "monitoring-periods",
    components: {
      DataTable,
    },
    data() {
      return {

        createOpen: true,
        sendOpen: true,  
  
        search_by_dropdown: 
          {
            selectedTableTab: [
              'name',
              'status',
              'start_date',
              'end_date',
            ],
          },
  
        selectedSearchBy: 'name',
        search: "",
        
  
        show: true,
        monitoringDataList: [],
        displayMPList: [],
        selectedMP: null,
        selectedMPName: "",

        displaySendMPList: [],
        selectedSendMP: null,
        selectedSendMPName: "",

        displayMPList_show: false,
        displayMPList_table: false,
        displaySendMPList_show: false,
        
        current_page: 1,
        page_size: 20,
        total_items: 100,
        perPageCount: 50,
        loading: false,
        show_modal: false,
        data_modal: null,
        current_row_index: null,
        filterOpen: false,
      };
    },
    watch: {
        "selectedMP": {
          handler: function () {
            this.upDataMPlist();
          },
          deep: true,
          immediate: true,
        },

        "selectedSendMP": {
          handler: function () {
            this.upDataSendMPlist();
          },
          deep: true,
          immediate: true,
        },

        "createOpen": {
          handler: function () {
            this.openParent();
          },
          deep: true,
          immediate: true,
        },
        "sendOpen": {
          handler: function () {
            this.openParent();
          },
          deep: true,
          immediate: true,
        },
    },
    computed: {
      filter_monitoring() {
        return this.displayMPList || [];
      },
      filter_Send_monitoring() {
        return this.displaySendMPList || [];
      },
    },
    mounted() {
      this.fetchMonitoringData(this.current_page);
    },
    methods: {
      openParent() {
        this.$emit('childOpen', this.createOpen, this.sendOpen);
      },
      handleOpenCreateFromParent() {
        this.createOpen = !this.createOpen;
      },
      handleOpenSendFromParent() {
        this.sendOpen = !this.sendOpen;
      },
      clearSelectedMP(){
        this.selectedMP = null;
        this.selectedMPName = "";
        this.displayMPList_show = false;
      },

      clearSelectedSendMP(){
        this.selectedSendMP = null;
        this.selectedSendMPName = "";
        this.displaySendMPList_show = false;
      },
  
      convertLabel(str) {
        // return convertToTitleCase(str);
        return str;
      },
  
      handleSelectSearchBy(search_by){
        this.selectedSearchBy = search_by;
      },

      handleSelectMP(selectedMP, selectedMPName) {
        this.selectedMP = selectedMP;
        this.selectedMPName = selectedMPName;
        // console.log(this.selectedMP);
      },

      handleSelectSendMP(selectedSendMP, selectedSendMPName) {
        this.selectedSendMP = selectedSendMP;
        this.selectedSendMPName = selectedSendMPName;
        // console.log(this.selectedMP);
      },

      upDataMPlist() {
        if (this.selectedMP != null && this.selectedMP != "") {
          this.displayMPList_show = true;
          const result = this.monitoringDataList.filter(item => item.id == this.selectedMP);
          this.displayMPList = result;
        }
      },

      upDataSendMPlist() {
        if (this.selectedSendMP != null && this.selectedSendMP != "") {
          const result = this.monitoringDataList.filter(item => item.id == this.selectedSendMP);
          this.displaySendMPList = result;
          this.displaySendMPList_show = true;
        }
      },

      async createVerraMP(){

        if (this.selectedMPName == "") {
          const MessageBox = `
                  <span class="moderat-meGreen">A Monitoring period must be selected from the dropdown.</span><br/>
                  `;
          return ElMessageBox.alert(MessageBox, {
                  confirmButtonText: "OK",
                  type: "error",
                  dangerouslyUseHTMLString: true,
                }).then(()=> {return;}).catch(()=>{return;});
        }
        let request = {
            selected_mp_name: this.selectedMPName,
        };

        const loadingInstance = createLoadingInstance('Creating monitoring report ...');
        await UserService.VerraCreateMonitoringPeriod(request)
          .then(
            (response) => {
              this.loading = false;
              loadingInstance.close();
            

              if (response.data.success == true) {
                const responseMessage = response.data.message;
                const dataID = response.data.data.id;
                const name = response.data.data.monitoringReportName;
                const startDate = response.data.data.monitoringPeriod.startDate;
                const endDate = response.data.data.monitoringPeriod.endDate;
                
                const MessageBox = `
                  <span class="moderat-meGreen-bold-16">${responseMessage}</span><br/>
                  <span class="moderat-meGreen">id: ${dataID}</span><br/>
                  <span class="moderat-meGreen">name: ${name}</span><br/>
                  <span class="moderat-meGreen">start date: ${startDate}</span><br/>
                  <span class="moderat-meGreen">end date: ${endDate}</span><br/>
                  `;

                ElMessageBox.alert(MessageBox, {
                  confirmButtonText: "OK",
                  type: "success",
                  dangerouslyUseHTMLString: true,
                }).then(()=> {return;}).catch(()=>{return;});
              } 
              
            },
            (error) => {

              this.loading = false;
              loadingInstance.close();
              const responseData = error?.response?.data || {};
              const mainMessage = responseData.message || error.message || "";
              const failedDetail = responseData.data?.failed || "";

              const MessageBox = `
                  <span class="moderat-meGreen">${mainMessage}</span><br/>
                  <span class="moderat-meGreen">${failedDetail}</span><br/>
                  `;
              ElMessageBox.alert(MessageBox,
               {
                 confirmButtonText: "OK",
                 type: "error",
                 dangerouslyUseHTMLString: true,
               }).then().catch(()=>{return;});
              console.log("error when create verraMP", error);
              }).catch((error)=>{
                console.log(error);
              }).finally(() => (this.loading = false));
      },

      sendVerraMP(){
        this.$emit("sendVerraMP", this.selectedSendMPName, this.displaySendMPList);
      },
  
      async fetchMonitoringData(page) {
        UserService.getMonitoringPeriods(
          this.selectedSearchBy,
          this.search,
          page,
          this.perPageCount,
          true // bypass pagination
        )
          .then(
            (response) => {
              this.monitoringDataList = response.data.monitoring_periods;
              this.total_items = response.data.total_record;
  
              // localStorage.setItem(
              //   "monitoringPeriods",
              //   JSON.stringify(this.monitoringDataList)
              // );
              sessionStorage.setItem(
                "monitoringPeriods",
                JSON.stringify(this.monitoringDataList)
              );

              // console.log(this.monitoringDataList);
              
  
            },
            (error) => {
              this.loading = false;
              console.log(error);
              if (error.response.status == 401) {
                this.$router.push({
                  path: "/",
                });
              }
            }
          )
          .catch((error) => {
            this.loading = false;
            console.log(error);
            if (error.response.status == 401) {
              this.$router.push({
                path: "/",
              });
            }
          })
          .finally(() => (this.loading = false));
      },
  
      // eslint-disable-next-line no-unused-vars
      handleRowClick(row, column, event) {
        // console.log(row, column, event);
      },
      // eslint-disable-next-line no-unused-vars
      close_modal(event) {
        this.show_modal = false;
      },
  
      confirm_modal(event) {
        if (this.monitoringDataList.length == this.current_row_index)
          this.monitoringDataList.push(event);
        else this.monitoringDataList[this.current_row_index] = event;
        this.show_modal = false;
      },
  
      handleShow(index, data) {
        this.current_row_index = index;
        this.data_modal = JSON.stringify(data);
        this.show_modal = true;
      },
  
      checkCurrentMP(){
        let current = this.monitoringDataList.filter((item) => item.status == "current");
        // console.log(current);
        if (current.length > 0) {
          const MessageBox = `
                  <span class="moderat-meGreen">There is already a current monitoring period</span><br/>
                  `;
            ElMessageBox.alert(MessageBox, {
              confirmButtonText: "OK",
              type: "warning",
            }).then(()=> {return;}).catch(()=>{return;});
          }
      },
  
      paginate(array, page_size, page_number) {
        return array.slice(
          (page_number - 1) * page_size,
          page_number * page_size
        );
      },
  
      handleExportFile() {
        if (this.filter_monitoring.length > 0) {
          const myHeader = ["start_date", "end_date", "status"];
          const ws = XLSX.utils.json_to_sheet(this.filter_monitoring, {
            header: myHeader,
          });
          const wb = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(wb, ws, "Data");
          XLSX.writeFileXLSX(wb, "MonitoringPeriodsList.xlsx");
        }
      },
  
      reset_filter(event) {
        this.current_page = 1;
        this.search = "";
        this.filter = event.filter;
      },
  
      handleTableAction() {
        // if (event.kind == true) {
        //   this.displayMPList_table = true;
        // } else if (event.kind == "edit") {
        //   this.handleShow(event.index, event.data);
        // } else if (event.kind == "delete") {
        //   this.deleteRow(event.data, event.index);
        // } else if (event.kind == "changePage") {
        //   this.current_page = event.index;
        //   this.fetchMonitoringData(this.current_page);
        // } else if (event.kind == "perPageChange") {
        //   this.current_page = 1;
        //   this.perPageCount = event.index;
        //   this.handleReload();
        // }
      },
  
      handleReload() {
        // this.fetchMonitoringData(this.current_page);
        this.createVerraMP();
      },

      handleSend() {
        // this.fetchMonitoringData(this.current_page);
        this.sendVerraMP();
      },

      filterSearch(event) {
        this.search = event.search;
      },
  
    },
  };
  </script>
  
  <style scoped>
  .el-table .warning-row {
    --el-table-tr-bg-color: var(--el-color-warning-light-8);
  }
  .el-table .error-row {
    --el-table-tr-bg-color: var(--el-color-error-light-8);
  }
  
  .v-enter-active,
  .v-leave-active {
    transition: opacity 0.5s ease;
  }
  
  .v-enter-from,
  .v-leave-to {
    opacity: 0;
  }
  
  .cell {
    text-align: center !important;
  }
  
  .starter-main .card-body ul {
    list-style-type: none !important;
  }
  
  .el-pager {
    -webkit-user-select: none !important;
    user-select: none !important;
    list-style: none !important;
    font-size: 0 !important;
    padding: 0 !important;
    margin: 0 !important;
    display: flex !important;
    align-items: center !important;
    position: relative !important;
    top: 0 !important;
    right: 0 !important;
  }
  
  .el-upload-list {
    margin: 10px 0 0 !important;
    padding: 0 !important;
    list-style: none !important;
    position: relative !important;
  }

  .svg-small{
    height: 10px;
    width: 10px;
    margin-left: 5px;
  }

  .selected-mp-wrapper {
    height: 30px;
    background-image: url('@/assets/svg/icon-sprite.svg#selected-filter'); /* Note: this won't work directly for sprites */
    background: no-repeat center/contain;
    position: relative;
    display: inline-flex;
    align-items: center;
    padding: 8px 16px;        /* 0.5rem = 8px, 1rem = 16px */
    border-radius: 10px;      /* 1rem = 16px */
    background-color: #F0EFEB; /* fallback if SVG as background fails */
    margin-left: 15px;
    margin-top: 10px;
  }

  .selected-mp-text {
    color: #0D3937;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.5px;
  }

  .clear-btn {
    margin-left: 5px; 
  }

  .el-dropdown.filter-drop > button {
    background: #47676A;
    border: 0;
    width: 243px;
}

  .text-white.pl-3 {
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    letter-spacing: 0.5px;
}

.el-dropdown-menu {
    min-width: 243px;
    height: 186px;
    flex-shrink: 0;
}

.el-dropdown-menu :deep(.el-dropdown-menu__item) {
    /* border-bottom: 1px solid transparent;  */
    border-top: 1px solid transparent; 
    border-bottom: 0.5px solid #547477;
    /* border-image: url('./line-150.png') 3; */
    padding: 10px 5px 10px 15px;
  }


  </style>
